import JsonLd from "@/components/base/JsonLd";
import Navbar from "../home/components/Navbar";
import Footer from "../home/components/Footer";
import CourseHero from "../inscricao/components/CourseHero";
import CourseIncludes from "../inscricao/components/CourseIncludes";
import CourseForWho from "../inscricao/components/CourseForWho";
import EnrollmentForm from "../inscricao/components/EnrollmentForm";
import CourseFAQ from "../inscricao/components/CourseFAQ";

const modules = [
  { number: "01", title: "Introdução da Clientizah" },
  { number: "02", title: "Introdução ao Curso" },
  { number: "03", title: "Conteúdo do Curso" },
  { number: "04", title: "Como ser um Lojista CAT" },
  { number: "05", title: "Conhecimento e Habilidades — Lojista CAT" },
  { number: "06", title: "Cultura organizacional, engajamento & Contratação de equipe" },
  { number: "07", title: "Gestão de relacionamento & Retenção de talentos" },
  { number: "08", title: "80/20 — Princípio de Pareto e Aumento das vendas" },
  { number: "09", title: "Branding x Marketing" },
  { number: "10", title: "Calendário & Planejamento de vendas" },
  { number: "11", title: "Como fazer uma Black Friday rentável" },
  { number: "12", title: "OTB & Sell-through" },
  { number: "13", title: "WhatsApp Business & CRM" },
  { number: "14", title: "Ferramentas de IA para o dia a dia da loja & Mídias virais" },
  { number: "15", title: "Venda com TikTok & TikTok Shop" },
  { number: "16", title: "Final do Curso" },
];

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "Course",
  name: "Método C.A.T — Lojista",
  description:
    "Feita para quem carrega o negócio nas costas e quer crescer com inteligência, previsibilidade e rentabilidade. Do planejamento financeiro ao posicionamento de marca para multimarcas, varejo e franquias.",
  provider: {
    "@type": "Organization",
    name: "Clientizah",
  },
  instructor: {
    "@type": "Person",
    name: "Gleice Lyra",
    jobTitle: "Especialista em Varejo, Multimarcas e Franquias",
  },
  timeRequired: "PT30H",
  educationalLevel: "Advanced",
  inLanguage: "pt-BR",
  offers: {
    "@type": "Offer",
    price: "1894.40",
    priceCurrency: "BRL",
    availability: "https://schema.org/LimitedAvailability",
  },
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: "4.9",
    reviewCount: "12000",
    bestRating: "5",
  },
};

export default function InscricaoLojista() {
  const siteUrl = (import.meta.env.VITE_SITE_URL as string) || "";

  return (
    <div className="relative min-h-screen bg-white">
      <title>Método C.A.T Lojista | Curso de Gestão para Donos de Loja | Clientizah</title>
      <meta name="description" content="Curso para lojistas que querem escalar o negócio, organizar o financeiro e criar marca forte no varejo. Método C.A.T da Clientizah com Gleice Lyra." />
      <meta name="keywords" content="curso lojista, gestão varejo, planejamento financeiro, precificação, Método CAT, Gleice Lyra, Clientizah, curso dono loja" />
      <link rel="canonical" href={`${siteUrl}/lojista`} />
      <JsonLd data={jsonLd} />
      <Navbar />
      <main className="pt-[160px]">
        <CourseHero
          badge="Vagas Limitadas"
          title="Método C.A.T"
          subtitle="Lojista"
          tagline="Cliente · Atenção · Todo tempo"
          description="Feita para quem carrega o negócio nas costas e quer crescer com inteligência, previsibilidade e rentabilidade. Do planejamento financeiro ao posicionamento de marca — um método construído com décadas de experiência em multimarcas, varejo e franquias para te entregar de forma clara, controle e escala. Você também terá acesso a todos os módulos da vendedora e gerente. Além de aulas personalizadas todos os meses para implantação do conteúdo."
          hours="+30 horas de conteúdo"
          bgSeq="coursehero-lojista"
        />
        <CourseIncludes modules={modules} totalHours="30" />

        <CourseForWho
          forWho={[
            {
              icon: "ri-store-2-line",
              title: "Lojistas que sentem que a loja não decola",
              desc: "Tem movimento, mas o caixa não fecha bem. Quer entender onde está perdendo dinheiro e como organizar o negócio para crescer de verdade.",
            },
            {
              icon: "ri-funds-line",
              title: "Donos de loja que querem escalar",
              desc: "Já tem um negócio funcionando e quer abrir uma segunda unidade, montar uma equipe sólida ou construir uma marca reconhecida.",
            },
            {
              icon: "ri-building-2-line",
              title: "Franqueados e multimarcas",
              desc: "Opera dentro de um sistema e precisa extrair o máximo do modelo — com gestão, atendimento e marketing específicos para o seu contexto.",
            },
            {
              icon: "ri-lightbulb-line",
              title: "Empreendedores que estão abrindo sua primeira loja",
              desc: "Quer começar estruturado, com clareza no financeiro, no estoque e na equipe — antes de cometer os erros que a maioria comete.",
            },
          ]}
          notForWho={[
            "Não é dono, sócio ou gestor de loja física ou e-commerce.",
            "Busca resultados imediatos sem precisar mudar processos ou comportamentos.",
            "Não tem interesse em entender financeiro, estoque ou gestão de equipe.",
          ]}
        />

        {/* Instructor */}
        <section className="py-16 px-6 md:px-16 bg-white border-t border-gray-100">
          <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-10">
            <div className="w-24 h-24 shrink-0 overflow-hidden rounded-full border-2 border-[#b8962e]/30">
              <img src="https://storage.readdy-site.link/project_files/6403a48a-1e3d-4a7f-80a1-63b2ebe85030/47b68a2a-669a-4028-a55a-db99149e15a8_Gleice.png?v=b1ce88b4ce58c92c6097cac96816f8c8"
                alt="Gleice Lyra" className="w-full h-full object-cover object-top" />
            </div>
            <div className="flex-1 text-center md:text-left">
              <p className="text-xs tracking-[0.3em] uppercase text-[#b8962e] font-medium mb-1">Sua instrutora</p>
              <h3 className="text-black text-xl font-semibold mb-2 tracking-tight">Gleice Lyra</h3>
              <p className="text-gray-500 text-sm leading-relaxed max-w-2xl">
                Especialista em varejo, vendas e comportamento do consumidor com mais de 15 anos de experiência transformando negócios em todo o Brasil.
              </p>
            </div>
            <div className="flex flex-col items-center gap-1 shrink-0">
              <span className="text-3xl font-bold text-black">+12k</span>
              <span className="text-xs text-gray-400 tracking-widest uppercase">Alunos formados</span>
            </div>
          </div>
        </section>

        <EnrollmentForm defaultCourseKey="lojista" />
        <CourseFAQ />
      </main>
      <Footer />
    </div>
  );
}
